let recaptchaLoaded = false;
let recaptchaLoading = false;
const loadCallbacks = [];

function getSiteKey() {
  return document.querySelector('meta[name="recaptcha-site-key"]')?.getAttribute('content') || '';
}

function loadRecaptchaScript() {
  if (recaptchaLoaded || recaptchaLoading) return;
  const siteKey = getSiteKey();
  if (!siteKey) return;

  recaptchaLoading = true;
  const script = document.createElement('script');
  script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
  script.async = true;
  script.defer = true;
  script.onload = () => {
    recaptchaLoaded = true;
    recaptchaLoading = false;
    loadCallbacks.forEach((cb) => cb());
    loadCallbacks.length = 0;
  };
  document.head.appendChild(script);
}

function onRecaptchaReady(cb) {
  if (recaptchaLoaded) {
    cb();
  } else {
    loadCallbacks.push(cb);
    loadRecaptchaScript();
  }
}

export function getRecaptchaToken(action) {
  const siteKey = getSiteKey();
  if (!siteKey) return Promise.resolve('');

  return new Promise((resolve) => {
    onRecaptchaReady(() => {
      window.grecaptcha.ready(() => {
        window.grecaptcha
          .execute(siteKey, { action })
          .then(resolve)
          .catch(() => resolve(''));
      });
    });
  });
}

export function initRecaptchaLazyLoad() {
  const siteKey = getSiteKey();
  if (!siteKey) return;

  const forms = document.querySelectorAll('.contact-form, #form-comment');
  if (!forms.length) return;

  const triggerLoad = () => {
    loadRecaptchaScript();
    // Remove listeners after first trigger
    forms.forEach((f) => {
      f.removeEventListener('focusin', triggerLoad);
      f.removeEventListener('pointerenter', triggerLoad);
    });
  };

  forms.forEach((f) => {
    f.addEventListener('focusin', triggerLoad, { once: true });
    f.addEventListener('pointerenter', triggerLoad, { once: true });
  });
}
